import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CloseBtnComponent } from "./close-btn/close-btn.component";
import { DynamicButtonComponent } from './dynamic-button/dynamic-button.component';
import { CreateBtnComponent } from "./create-btn/create-btn.component";
import { SubmitBtnComponent } from './submit-btn/submit-btn.component';
import { CancelBtnComponent } from './cancel-btn/cancel-btn.component';
import { ButtonFooterComponent } from './button-footer/button-footer.component';

const comlist=[
  CloseBtnComponent,
  DynamicButtonComponent,
  CreateBtnComponent,
  SubmitBtnComponent,
  CancelBtnComponent,
  ButtonFooterComponent
]
@NgModule({
  declarations: [
    comlist,
  ],
  imports: [
    CommonModule,
    
  ],
  exports:[
    comlist
  ]
})
export class ButtonGpModule { }
